// Phone number handling for the SMS queue flow.
//
// The SMS operator rejects numbers sent without a country code (error 11,
// "Countrycode not allowed"), and customers naturally type the national form,
// so normalize before anything is sent or stored. The backend applies the same
// rule in SmsController::toMsisdn().
const DEFAULT_COUNTRY_CODE = "47"; // Norway

// Returns the number as +<countrycode><subscriber>, or null when it is too
// short to be a real number.
export const normalizePhone = (input) => {
    const digits = String(input || "").replace(/[^0-9]/g, "");

    if (!digits) return null;

    // International form written with the 00 trunk prefix (0047...).
    if (digits.startsWith("00")) {
        return digits.length > 10 ? `+${digits.slice(2)}` : null;
    }

    // Norwegian mobile numbers are 8 digits without the country code.
    if (digits.length === 8) return `+${DEFAULT_COUNTRY_CODE}${digits}`;

    // Longer than the national format: already carries a country code.
    if (digits.length > 8) return `+${digits}`;

    return null;
};
